<template>
  <section id="tour_details_main" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="section_heading_center">
            <h2>{{ $t("about_us") }}</h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="terms_service_content">
            <div class="terms_item">
              <p style="text-align: justify;" v-html="$t('us_p1')"></p>
              <p style="text-align: justify;" v-html="$t('us_p2')"></p>
              <p style="text-align: justify;" v-html="$t('us_p3')"></p>
              <p style="text-align: justify;" v-html="$t('us_p4')"></p>
              <p style="text-align: justify;" v-html="$t('us_p5')"></p>
              <p style="text-align: justify;" v-html="$t('us_p6')"></p>
              <p style="text-align: justify;" v-html="$t('us_p7')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "PrivacyPolicyContent",
};
</script>
